import Vue from 'vue'
import VueRouter from 'vue-router'
import Loadpage from '@/components/Loadpage'
import PageEdit from '@/components/Page-edit'

import EducationalWorkshops from '@/components/Educational-workshops'
import EducationalWorkshopsEvento from '@/components/Educational-workshops-evento'
import ProgrammaEvento from '@/components/Programma-evento'


Vue.use(VueRouter)

var mode = (process.env.NODE_ENV != 'development') ? 'history' : 'hash'

export default new VueRouter({

  mode: mode,
  base: '/2019/',

  scrollBehavior (to, from, savedPosition) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({ x: 0, y: 0 })
      }, 500)
    })
  },

  routes: [
    { path: '/',  redirect: '/home'},
    
    { path: '/home', name: 'home', meta: { nav: true }, components:{main: Loadpage  }, props: {main: true, page:'mirko' } }, 
    { path: '/loadpage/:area/:filename', name: 'inside',  meta: { inside:'inside', nav: true }, components:{main: Loadpage },props: {main: true} }, 
    { path: '/page-edit', name: 'pageEdit', meta: { requiresAuth: false }, components: { main: PageEdit } },

    { path: '/educational-workshops', name: 'educationalWorkshops', meta: { requiresAuth: false }, components: { main: EducationalWorkshops } },
    { path: '/educational-workshops-dettaglio/:evento*', name: 'educational.workshops.dettaglio', meta: { inside:'inside', nav: true }, components:{main: EducationalWorkshopsEvento } },

    { path: '/dettaglio/:evento*', name: 'evento', meta: { inside:'inside', nav: true }, components:{main: ProgrammaEvento } },

    { path: '/home', name: 'home', meta: { nav: true }, components:{main: Loadpage  }, props: {main: true, page:'mirko' } }, 
    

    { path: '*', redirect: '/home' } 
  ]


})
